<template>
  <div class="grid-content bg-purple">
    <h2 style="text-align: left;margin-left: 25px">修改密码</h2>
    <el-form ref="form" label-width="150px">
      <el-form-item label="密码：">
        <el-input v-model="updataform.pwd" type="password" placeholder="密码"></el-input>
      </el-form-item>
      <el-form-item label="确认密码：">
        <el-input v-model="updataform.spwd" type="password" placeholder="确认密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="updatePassWord()">确认提交</el-button>

      </el-form-item>
    </el-form>
  </div>

</template>
<script>
export default ({
    name:"Install",
    data(){
      return {
              updataform: {
                pwd:'',
                spwd: '',
              },

            }
    },
         beforeRouteEnter(to,from,next){

             next((vm)=>{

             });
         },
        created(){

        },
        mounted () {

        },
        methods: {
          //修改当前用户密码
          updatePassWord(){
            let that = this;
            if (that.updataform.pwd == '') {
              that.$message.error('请输入密码');
              return false;
            }
            if (that.updataform.pwd == '') {
              that.$message.error('请输入密码');
              return false;
            }
            if (that.updataform.spwd == '') {
              that.$message.error('请输入确认密码');
              return false;
            }
            if (that.updataform.pwd != that.updataform.spwd) {
              that.$message.error('密码输入不一致');
              return false;
            }
            var updataformdata = {
              passWord:that.updataform.pwd,
              confirmPassWord:that.updataform.spwd
            }
            this.$axios
              .post('/api/user/updatePassWord', updataformdata)
              .then(function (res) {
                if (res.data.code == 500) {
                  that.$message.error("密码修改失败:"+res.data.msg);
                  return false;
                } else if (res.data.code == 200) {
                  that.$message({
                    message: '密码修改成功',
                    type: 'success'
                  });
                  //  this.show == true;
                  window.setTimeout(() => {
                    location.reload();
                  }, 1000);
                }
              }).catch(function (error) { // 请求失败处理
              console.log("服务器错误"+error);
            });
          },

        },
        watch: {

        },


})
</script>

<style scoped>

.el-form {
  width: 577px;
}
.el-form-item {
  margin-bottom: 22px;
}

.el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
  margin-left: 150px;
}
/deep/ .el-button--primary {
  width: auto!important;
  margin-bottom: 30px;
  margin-top: 0px!important;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/Install.vue